export interface ICareerTeam {
  slug: string;
  title: string;
  quote: string;
  tagStyle: string;
}
export const teams: readonly ICareerTeam[] = [
  { slug: 'marketing', title: 'Команда маркетинга и ПРОДАЖ', quote: '«ПЛАН? УЖЕ ПЕРЕВЫПОЛНИЛИ»', tagStyle: '' },
  { slug: 'analytics', title: 'Команда \nаналитики', quote: '«ЦИФРЫ СОШЛИСЬ»', tagStyle: 'is-beige' },
  { slug: 'technologies', title: 'Команда \nТехнологий', quote: '«У МЕНЯ ЛОКАЛЬНО ЗАВЕЛОСЬ»', tagStyle: 'is-beige' },
  { slug: 'product', title: 'Команда \nпродукта', quote: '«ЭТО УЖЕ В РОУДМАПЕ»', tagStyle: 'is-beige' },
  { slug: 'backoffice', title: 'Команда \nбэкофиса', quote: '«Работаем, чтобы всё работало»', tagStyle: 'is-beige' },
];
